import { useEffect } from 'react';
import { useUserStore } from '../stores/userStore';

export const useTokenCheck = () => {
  const { token, checkAuth } = useUserStore();

  useEffect(() => {
    // Run immediately on mount if we have a token
    if (token) {
     
      checkAuth()

      // Then set up periodic checks
      const checkInterval = setInterval(() => {
        console.log('Running periodic token check...');
        checkAuth();
      }, 5 * 60 * 1000); // Check every 5 minutes

      return () => clearInterval(checkInterval);
    }
  }, [token, checkAuth]);
};